<h2 mat-dialog-title>
  <div class="header">
    <mat-icon>new_releases</mat-icon>
    What's new
  </div>
</h2>
<mat-dialog-content>
  <ul class="highlights">
    @for (section of data.sections; track $index) {
      <li class="highlight">
        <p class="highlight-title">{{ section.title }}</p>
        <p class="highlight-description">{{ section.description }}</p>
      </li>
    }
  </ul>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="release-highlights-close-button" mat-flat-button color="primary" [mat-dialog-close]="true">Got it</button>
</mat-dialog-actions>
